import type { LegalPageContent } from "./legalTerms";

const legalPrivacy: LegalPageContent = {
  title: "Privacy Policy",
  metaDescription: "Privacy policy for the public Legache website at https://legache.com.",
  lastUpdated: "March 9, 2026",
  sections: {
    Introduction: [
      "This Privacy Policy explains how Legache, a division of Waypoint, Inc. (\"Legache\", \"we\", \"us\", or \"our\") collects, uses, and discloses information in connection with the public Legache website at https://legache.com (the \"Website\").",
      "This Privacy Policy applies to the public marketing website only.",
      "If you access or use the Cassandra platform at https://cassandra.legache.com, your use of that platform is governed by separate platform-specific privacy and legal disclosures available there."
    ],
    "Information We Collect": [
      "Information you provide directly",
      "• If you contact us by email or through other direct communication channels referenced on the Website, we may collect your name, email address, organization, role, message contents, and any other information you choose to provide.",
      "Usage and device data",
      "• We may collect information about how the Website is accessed and used, including browser type, device information, pages viewed, timestamps, referrer information, approximate geolocation derived from IP address, and similar technical usage data.",
      "Analytics and diagnostics data",
      "• We and our service providers may collect cookie-related, performance, interaction, and diagnostic information to help us understand Website traffic, measure site effectiveness, and identify site errors."
    ],
    "How We Use Information": [
      "We may use collected information to:",
      "• operate, maintain, and improve the Website;",
      "• respond to inquiries and communicate with you;",
      "• understand usage patterns and evaluate Website performance;",
      "• detect, investigate, and address security, fraud, abuse, or technical issues;",
      "• comply with legal obligations and protect our rights, property, and users;",
      "• support business, recruiting, partnership, research, or product-related discussions that you initiate or request."
    ],
    "Analytics, Cookies, and Similar Technologies": [
      "The Website may use cookies and similar technologies to measure traffic, understand audience behavior, and improve the Website.",
      "We use Google Analytics to help us understand Website traffic and usage patterns. Google Analytics may collect browser, device, page-view, and cookie-related information subject to Google's own terms and privacy practices.",
      "You can manage cookies through your browser settings, but doing so may affect how some parts of the Website function.",
      "For more information about Google Analytics, please visit https://policies.google.com/privacy?hl=en and https://support.google.com/analytics/answer/4597324?hl=en."
    ],
    "Error Monitoring and Diagnostics": [
      "We use Sentry to receive error reports and operational diagnostics that help us identify, investigate, and fix Website issues.",
      "Our Sentry configuration is intended to redact certain sensitive request fields where practicable, but diagnostic data may still include technical information related to your use of the Website.",
      "For more information, please visit https://sentry.io/privacy/."
    ],
    "Service Providers": [
      "We may use third-party service providers to host, secure, monitor, analyze, and support the Website.",
      "These service providers may process information on our behalf as reasonably necessary to perform their services and are subject to their own legal and contractual obligations."
    ],
    "Disclosure of Information": [
      "We may disclose information we collect or you provide:",
      "• to our affiliates and service providers that help operate, secure, analyze, or support the Website;",
      "• to respond to or fulfill the purpose of your inquiry or request;",
      "• when required by law, legal process, or valid governmental request;",
      "• when we believe disclosure is necessary to protect our rights, property, users, or the security or integrity of the Website;",
      "• in connection with a merger, acquisition, financing, reorganization, sale of assets, or similar transaction;",
      "• with your consent or at your direction."
    ],
    "Retention of Data": [
      "We retain information for as long as reasonably necessary to operate and improve the Website, respond to inquiries, maintain records, comply with legal obligations, resolve disputes, and enforce our agreements.",
      "Retention periods may vary based on the type of information and the purpose for which it was collected."
    ],
    "Transfer of Data": [
      "Information processed in connection with the Website may be transferred to and processed in jurisdictions other than your own.",
      "By using the Website or providing information through it, you understand that your information may be processed in jurisdictions with different data protection laws, subject to applicable law."
    ],
    "Security of Data": [
      "We use commercially reasonable administrative, technical, and organizational measures designed to protect information processed through the Website.",
      "No method of transmission over the Internet or method of electronic storage is completely secure, and we cannot guarantee absolute security."
    ],
    "Links to Other Sites": [
      "The Website may contain links to third-party sites or services, including the Cassandra platform and other external resources.",
      "If you visit a third-party site or service, its privacy practices are governed by that third party, not by us. We encourage you to review the privacy policy of every external site or service you use."
    ],
    "Changes to This Privacy Policy": [
      "We may update this Privacy Policy from time to time by posting the revised version on this page.",
      "Changes become effective when posted unless otherwise stated. We encourage you to review this page periodically for updates."
    ],
    "Contact Us": [
      "If you have questions about this Privacy Policy, please contact us at contact@legache.com."
    ]
  }
};

export default legalPrivacy;
